import { gql } from '@apollo/client';

export const START_ASSET2_VAST_INGESTION_BY_COUNTRY_LIST = gql`
  mutation StartAsset2VastIngestionByCountryList(
    $creativeLibraryId: ID!
    $creativeId: ID!
    $vastUrl: String!
    $countries: [String!]!
  ) {
    startAsset2VastIngestionByCountryList(
      creativeLibraryId: $creativeLibraryId
      creativeId: $creativeId
      vastUrl: $vastUrl
      countries: $countries
    ) {
      failure {
        id
        message
      }
      success {
        id
        mediaUrl
      }
    }
  }
`;
